// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4227":"fa96ed54","5537":"9eb5846e","6483":"68588927","8423":"d2c02c78"}[chunkId] + ".chunk.css";
};